/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycSourceOfFundsObservationsDto } from '../../models/kyc-source-of-funds-observations-dto';

export interface GetSourceOfFundsObservations$Params {
  processId: string;
}

export function getSourceOfFundsObservations(http: HttpClient, rootUrl: string, params: GetSourceOfFundsObservations$Params, context?: HttpContext): Observable<StrictHttpResponse<KycSourceOfFundsObservationsDto>> {
  const rb = new RequestBuilder(rootUrl, getSourceOfFundsObservations.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycSourceOfFundsObservationsDto>;
    })
  );
}

getSourceOfFundsObservations.PATH = '/kyc/processes/{processId}/source-of-funds-observations';
